import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../../config/themes/variables/mediaqueries';

export const StyledBoxInputDivision = styled.div`
  margin-bottom: ${rem('10px')};
  order: 1;
  padding-bottom: ${rem('9px')};
  position: relative;
  width: 100%;

  ${mediaqueries.greaterThan('tablet')`
    padding: 0 ${rem('15px')} ${rem('9px')} 0;
    width: 50%;
  `};

  ${mediaqueries.greaterThan('desktop')`
    margin: 0 0 0 ${rem('36px')};
    padding-bottom: 0;
    width: 100%;
  `};
`;

export const StyledBoxInputDivisionTwo = StyledBoxInputDivision.extend`
  ${mediaqueries.greaterThan('tablet')`
    padding: 0 0 ${rem('9px')} ${rem('15px')};
  `};

  ${mediaqueries.greaterThan('desktop')`
    padding-bottom: 0;
  `};
`;

export const StyleWrapIcon = styled.div`
  flex-basis: ${rem('25px')};
  margin-left: auto;
  order: 3;

  ${mediaqueries.greaterThan('desktop')`
    flex-basis: 12rem;
    margin: ${rem('8px')} 0 0;
    padding-bottom: 0;
  `};
`;
